import api, { requiresAccountId } from "../_app/api";
import { Brand, SupportContact } from "./types";

export const getBrand = async (groupId: string | undefined) => {
  const { data }: { data: Brand } = await api({
    method: "GET",
    url: "/brands/my",
    params: groupId ? { "group-id": groupId } : {},
  });
  return data;
};

export const getSupportContact = async (accountId: string | undefined) => {
  requiresAccountId(accountId);
  const { data }: { data: SupportContact } = await api({
    method: "GET",
    url: `/accounts/${accountId}/support`,
    params: { "account-id": accountId },
  });
  return data;
};
